export class Feeds {
  ical: string

  public static fromJson(data: any): Feeds {
    let feed = new Feeds();
    feed.ical = data.ical;
    return feed;
  }
}
